import { createContext, useContext } from 'react'

/**
 * CC-49594: lets SpecializedReportShell receive the export view published by
 * whichever universal grid its report page renders (CsvReportGrid →
 * ReportDataGrid/ReportGroupedGrid), without threading a ref through all 17
 * specialized report pages. The shell provides { ref, onPublish }; the grid
 * wrapper stores its view getter on `ref` and calls `onPublish()` so the
 * shell knows a PDF-able view exists.
 */
export const ReportExportViewContext = createContext(null)
export const useReportExportView = () => useContext(ReportExportViewContext)
